"use client";

import PopularListItemCard from "@/components/PopularListItemCard";
import RouteCard from "@/components/pages/bus/cards/RouteCard.jsx";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";

import { 
  CampaignCard, 
  BenefitCard, 
  BrandCard, 
  RegisterBanner,
  PopularLocationCard,
  AppBanner,
  IconText
} from "@/components/featured/common";

import { 
  TravelDealCard,
  RouteDealCard,
  CommonListItemCard,
  BlogCard,
} from "@/components/featured/bus";

export const componentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  PopularLocationCard,
  PopularListItemCard,
  CommonListItemCard,
  BenefitCard,
  BrandCard,
  BlogCard,
  AppBanner,
  RegisterBanner,
  RouteCard,
  TravelDealCard,
  RouteDealCard,
  IconText
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  PopularLocationCard: "item",
  PopularListItemCard: "item",
  CommonListItemCard: "item",
  BenefitCard: "item",
  BrandCard: "brand",
  BlogCard: "post",
  RouteCard: "item",
  TravelDealCard: "item",
  RouteDealCard: "item",
};
